<template>
  <div class="logistics-info-box">
    <div class="nav-bar">
      <view
        class="navItem"
        v-for="item in logisticsTitle"
        :key="item.id"
        @click="selectFunction(item.id)"
        :class="{ choseItem: logisticsId == item.id }"
      >
        {{ item.text }}
      </view>
    </div>
    <div class="Fixedsource-list">
      <div
        v-for="item in currentPageData"
        :key="item.id"
        class="zlt-container"
        @click="() => handleViewDetail(item)"
      >
        <div class="header">
          <div class="item start-address">
            <span class="city-text">
              {{ item.startProvince }}{{ item.startCity }}
            </span>
          </div>
          <img src="@/assets/Bluearrow.png" alt="" class="arrow-icon" />
          <div class="item end-address">
            <span class="city-text">
              {{ item.endProvince }}{{ item.endCity }}
            </span>
          </div>
        </div>
        <div class="zlt-content">
          <div style="display: flex; font-size: 14px; font-weight: 500; margin-bottom: 8px;">
            <span v-if="item.pricingType == 1" class="type-tag fixed">系统计价</span>
            <span v-else-if="item.pricingType == 2" class="type-tag quotation">物流报价</span>
            <span v-else-if="item.pricingType == 3" class="type-tag bidding">物流竞价</span>
            <span style="color: #005dff; padding: 2px 8px; box-sizing: border-box; border: 1px solid #005dff; margin-left: 8px;">整车运输</span>
          </div>
          <div class="desc-row">
            <span class="desc-label">重量体积</span>
            <span class="desc-value">{{ item.weight }} / {{ item.volume }}</span>
          </div>
          <div class="desc-row">
            <span class="desc-label">发布时间</span>
            <span class="desc-value">{{ item.time }}</span>
          </div>
          <div v-if="item.pricingType == 1" class="price-red">{{ item.price }}</div>
          <div v-else-if="item.pricingType == 2" class="price-link">
            去报价
            <img src="@/assets/blueArrowS.png" alt="price" />
          </div>
          <div v-else-if="item.pricingType == 3" class="price-link">
            去竞价
            <img src="@/assets/blueArrowS.png" alt="price" />
          </div>
        </div>
        <div class="footer">
          <div class="name">货源商：{{ item.carrier }}</div>
          <img src="@/assets/zhuXTlogo.png" class="logo" alt="" />
          <img src="@/assets/rightArrow.png" alt="" class="arrow-icon" />
          <div class="btns">
            <div class="btn">包接</div>
            <div class="btn">包送</div>
          </div>
        </div>
        <div style="display: flex; color: rgba(0, 27, 81, 0.4); font-size: 16px; margin-top: 8px;">
          {{ item.views }} 浏览 | {{ item.consultation }} 咨询
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pagination">
        <button class="page-btn" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">
          <img src="@/assets/leftArrow.png" alt="Left Arrow" />
        </button>
        <button v-for="page in totalPages" :key="page" @click="changePage(page)" :class="{ active: currentPage === page }">
          {{ page }}
        </button>
        <button class="page-btn" :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">
          <img src="@/assets/rightArrow.png" alt="Right Arrow" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getGwWlOrderList } from '@/apis/modules/logistics/index.js';
import { ElMessage } from 'element-plus';

export default {
  name: 'FreightInfo',
  data() {
    return {
      logisticsTitle: [
        { id: 1, text: '国内物流' },
        { id: 2, text: '国际物流' },
        { id: 6, text: '工厂企业' },
        { id: 3, text: '实时车源' },
        { id: 4, text: '实时货源' },
        // { id: 5, text: '物流园区' }
      ],
      logisticsId: 4,
      dataList: [],
      currentPage: 1,
      itemsPerPage: 4
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.dataList.length / this.itemsPerPage) || 1;
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.dataList.slice(start, end);
    }
  },
  methods: {
    selectFunction(id) {
      if (id === 2 || id === 3) {
        ElMessage({ message: '该功能未开放，敬请期待！', type: 'warning' });
        return;
      }
      this.logisticsId = id;
      this.$emit('selectLogistics', id);
    },
    handleViewDetail(item) {
      this.$router.push({
        name: 'FreightQuotation',
        query: {
          id: item.id,
          startProvince: item.startProvince,
          startCity: item.startCity,
          endProvince: item.endProvince,
          endCity: item.endCity,
          pricingType: item.pricingType,
          time: item.time,
        }
      });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    async fetchList() {
      try {
        const params = { pageNo: 1, pageSize: 4 };
        const res = await getGwWlOrderList(params);
        if (res && res.statusCode === 20000 && Array.isArray(res.data)) {
          this.dataList = res.data.map(item => ({
            id: item.id,
            startProvince: item.senderAddressInfo?.province || '',
            startCity: item.senderAddressInfo?.city || '',
            endProvince: item.consigneeAddressInfo?.province || '',
            endCity: item.consigneeAddressInfo?.city || '',
            weight: (item.totalWeight || 0) + 'kg',
            volume: (item.totalVolume || 0) + 'm³',
            time: item.orderTime,
            price: '￥' + (item.actualPrice || 0),
            carrier: item.placeCompanySampleName || '',
            views: '999+',
            consultation: '999+',
            pricingType: item.pricingType,
          }));
        }
      } catch (e) {
        console.error('获取货源列表失败', e);
      }
    }
  },
  mounted() {
    this.fetchList();
  }
};
</script>

<style scoped lang="scss">
.logistics-info-box {
  width: 924px;
  min-height: 880px;
  background: white;
  box-sizing: border-box;
  padding: 8px 24px 0px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .nav-bar {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 24px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: rgba(0, 27, 81, 0.4);
    box-sizing: border-box;
    margin-bottom: 24px;
    .navItem {
      display: flex;
      align-items: center;
      height: 64px;
      margin-right: 80px;
      padding-bottom: 4px;
      color: rgba(0, 27, 81, 0.4);
      border-bottom: 4px solid rgba(0, 0, 0, 0);
      cursor: pointer;
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: normal;
      color: rgba(0, 27, 81, 0.4);
    }
    .choseItem{
      border-bottom: 6px solid #001B51;
      color: #001B51;
      font-weight: bold;
    }
  }
}
.Fixedsource-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.zlt-container {
  position: relative;
  padding: 15px 0 15px 25px;
  background: linear-gradient(180deg, #f1f7ff 0%, #f1f7ff 100%);
  cursor: pointer;
  min-height: 260px;
  width: 434px;
  margin: 0 auto;
  box-sizing: border-box;
  transition: box-shadow 0.2s;
  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    z-index: 1;
    opacity: 0;
    background-color: transparent;
  }
  &:hover {
    background: linear-gradient(180deg, #f1f6ff 0%, #ffffff 100%);
    box-shadow: 0px 10px 16px 0px rgba(0, 27, 81, 0.2);
    &::after {
      opacity: 1;
      background-color: #076aff;
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 0;
    background: none !important;
    box-shadow: none !important;
    .arrow-icon {
      width: 30px;
      height: 10px;
      margin: 0 10px;
    }
    .item {
      width: 160px;
      height: 60px;
      font-size: 20px;
      font-weight: bold;
      color: #001b51;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      overflow: hidden;
      word-break: break-all;
      position: relative;
      padding-left: 28px;
      .city-text {
        display: block;
        width: 100%;
        text-align: center;
        margin: 0 auto;
      }
      &::before {
        content: '始';
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        width: 24px;
        height: 24px;
        left: 0;
        border-radius: 3.43px;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        font-size: 13.7px;
        color: #fff;
        background-color: #1dc054;
      }
      &.end-address {
        &::before {
          content: '终';
          background-color: #f4333c;
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    width: 380px;
    color: #001b51;
    margin-top: 13px;
    padding: 8px 0 8px 16px;
    background: linear-gradient(
      90deg,
      #e0edff 44%,
      rgba(224, 237, 255, 0) 100%
    );
    .name {
      margin-right: 8px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
    .logo {
      width: 72px;
      height: 30px;
      margin-right: 8px;
      flex-shrink: 0;
    }
    .arrow-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
    .btns {
      display: flex;
      gap: 0;
      margin-left: auto;
      .btn {
        padding: 2px 8px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        border-radius: 4px 4px 4px 4px;
        margin-right: 0;
        margin-left: 0;
        margin-bottom: 0;
        margin-top: 0;
        background: #005dff;
        border: none;
        cursor: default;
        box-shadow: none;
        &:nth-child(2) {
          background: #1dc054;
          margin-left: 8px;
        }
      }
    }
  }
}
.zlt-content {
  margin-top: 10px;
}
.desc-row {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 4px;
}
.desc-label {
  color: #7a8599;
  min-width: 80px;
}
.desc-value {
  color: #001b51;
  font-weight: 500;
}
.price-red {
  color: #f4333c;
  font-size: 24px;
  font-weight: 700;
  margin: 10px 0 0 0;
  text-align: left;
  justify-content: flex-start;
}
.price-link {
  color: #005dff;
  font-size: 24px;
  font-weight: 700;
  margin: 10px 0 0 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: flex-start;
}
.price-link img {
  margin-left: 4px;
  height: 18px;
}
.type-tag {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 2px 8px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  margin-right: 8px;
}
.type-tag.fixed {
  background: #005dff;
}
.type-tag.quotation {
  background: #1dc054;
}
.type-tag.bidding {
  background: #f4333c;
}
.page {
  width: 344px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  .pagination {
    box-sizing: border-box;
    margin-top: 32px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .page-btn {
      cursor: pointer;
      display: flex;
      width: 24px;
      height: 24px;
      padding: 0px;
      background-color: #ffffff;
      border: none;
    }
    .page-btn:disabled {
      cursor: not-allowed;
      opacity: 0.2;
      background: #ffffff;
    }
    button {
      color: rgba(0, 27, 81, 0.4);
      border: none;
      width: 40px;
      height: 40px;
      background: rgba(0, 27, 81, 0);
      cursor: pointer;
    }
    button.active {
      color: white;
      border: none;
      width: 40px;
      height: 40px;
      background: #001b51;
    }
  }
}
</style>
